import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';

const lang = '';

class News20161118001 extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '新聞中心',
      'sc': '新闻中心',
      'en': 'News Center'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      News20161118001JSX(this)
    );
  }
}

const News20161118001JSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper newsdt'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '新聞',
                    'sc': '新闻',
                    'en': 'News'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='newsdt-container'>
          <Grid container spacing={0} className='newsct' id='grid-section' justify='center'>
            <Grid item xs={12} sm={8} md={10} className='news-title theme-color'>
              <span>
                {
                  ctx.getLangText({
                      'tc': '鑫匯寶貴金屬榮膺“最佳黃金交易平台”獎',
                      'sc': '鑫汇宝贵金属荣膺“最佳黄金交易平台”奖',
                      'en': 'Xinhuibao Precious Metals won the China Financial Annual Champion Best Precious Metals Trading Platform Awards'
                  })
                }
              </span>
            </Grid>
            <Grid item xs={12} sm={4} md={2} className='news-date'>
              <span>2016.11.18</span>
            </Grid>
          </Grid>

          <Grid item style={{width:'100%', marginBottom:'30px'}}><hr/></Grid>

          <Grid container spacing={0} className='content-container'>
            <Grid item>
              <p>
                {
                  ctx.getLangText({
                      'tc': `近日，第13屆中國財經風雲榜黃金行業頒獎典禮在深圳隆重舉行。眾多金企參與此次最具權威性和影響力的行業評選活動。根據評比規則，在公正透明的原則下，共評出各類獎項。匯寶資本集團旗下鑫匯寶貴金屬有限公司榮膺“最佳黃金交易平台”獎，再次以良好的服務和平台的正規性獲得了社會各界及業內人士的重大肯定。`,
                      'sc': `近日，第13届中国财经风云榜黄金行业颁奖典礼在深圳隆重举行。众多金企参与此次最具权威性和影响力的行业评选活动。根据评比规则，在公正透明的原则下，共评出各类奖项。汇宝资本集团旗下鑫汇宝贵金属有限公司荣膺“最佳黄金交易平台”奖，再次以良好的服务和平台的正规性获得了社会各界及业内人士的重大肯定。`,
                      'en': `The 13th China Financial Annual Champion Awards - precious metals Business, the award ceremony was held in Shenzhen. Many precious Metals Merchants participated in this most authoritative and influential industry selection activity. According to the evaluation rules, under the principle of fairness and transparency, various awards were evaluated. Xinhuibao Precious Metals  Co., Ltd., a subsidiary of Huibao Capital Group, won the “Best Precious Metals Trading Platform” award, and once again won the great recognition from all walks of life and the industry with good service and formality of the platform.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `此次評選中，參評企業必須是上海黃金交易所、上海期貨交易所、天津貴金屬交易所、香港金銀貿易場會員單位。鑫匯寶貴金屬有限公司是香港金銀業貿易場106號AA類（最高類）行員，持有AA類別市場交易有效營業牌照。`,
                      'sc': `此次评选中，参评企业必须是上海黄金交易所、上海期货交易所、天津贵金属交易所、香港金银贸易场会员单位。鑫汇宝贵金属有限公司是香港金银业贸易场106号AA类（最高类）行员，持有AA类别市场交易有效营业牌照。`,
                      'en': `In this selection, the participating companies must be members of the Shanghai Gold Exchange, Shanghai Futures Exchange, Tianjin Precious Metals Exchange, and Hong Kong The Chinese Gold & Silver Exchange Society. Hong Kong Xinhuibao Precious Metals Co., Ltd. is a member of The Chinese Gold & Silver Exchange Society (member No. 106) and holds AA types of market trading license.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `自成立以來，鑫匯寶貴金屬按照香港金銀貿易場會員管理辦法，堅持合規、自律、誠信的原則開展各項業務經營。憑著嚴密而有效的規章制度、規範的交易行為以及從業人員的信守精神，鑫匯寶貴金屬正以快速發展的姿態贏得了越來越多投資者的信賴，成為香港一家新興崛起的現貨合約交易商。`,
                      'sc': `自成立以来，鑫汇宝贵金属按照香港金银贸易场会员管理办法，坚持合规、自律、诚信的原则开展各项业务经营。凭着严密而有效的规章制度、规范的交易行为以及从业人员的信守精神，鑫汇宝贵金属正以快速发展的姿态赢得了越来越多投资者的信赖，成为香港一家新兴崛起的现货合约交易商。`,
                      'en': `Since its inception,  Xinhuibao Precious Metals Co., Ltd., strict compliance with the Chinese Gold & Silver Exchange Society  norms. Adhere to the principles of compliance, self-discipline and integrity to carry out various business operations. With strict and effective rules and regulations, standardized trading behaviours and the spirit of the employees,  Xinhuibao precious metals have won the trust of more and more investors with a rapid development attitude, and become a new rise company in Hong Kong Contract dealer.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `作為香港金銀業貿易場的規範行員，鑫匯寶貴金屬遵守貿易場嚴格規範和監管。公司提供貿易場交易編碼供核實成交記錄、歷史分筆報價數據查詢等服務措施，使交易的透明度得到了有效保障。客戶資金完全獨立存管於專屬銀行托管戶口，確保不被挪用。`,
                      'sc': `作为香港金银业贸易场的规范行员，鑫汇宝贵金属遵守贸易场严格规范和监管。公司提供贸易场交易编码供核实成交记录、历史分笔报价数据查询等服务措施，使交易的透明度得到了有效保障。客户资金完全独立存管于专属银行托管户口，确保不被挪用。`,
                      'en': `As a member of The Chinese Gold & Silver Exchange Society,  Xinhuibao Precious Metals strict compliance with the Chinese Gold & Silver Exchange Society (CGSE) norms. We provide transaction codes for verification of transaction records, historical quotation data etc..., so that the transparency of the transaction is effectively to protect client. Segregates Client funds to ensure that they are not misappropriated.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `鑫匯寶貴金屬為客戶打造一級服務體系，在線咨詢、開戶交易、資訊服務、模擬交易、金銀日評、策略播報等依托互聯網平台。優質、專業的互聯網平台建設和服務，穩定的MT4交易系統、安全的資金管理、全天候的精英團隊咨詢服務等。公司致力於不斷提升客戶交易體驗、提高專業品質、樹立優秀服務品牌，務求為客戶帶來更完美的投資感受。`,
                      'sc': `鑫汇宝贵金属为客户打造一级服务体系，在线咨询、开户交易、资讯服务、模拟交易、金银日评、策略播报等依托互联网平台。优质、专业的互联网平台建设和服务，稳定的MT4交易系统、安全的资金管理、全天候的精英团队咨询服务等。公司致力于不断提升客户交易体验、提高专业品质、树立优秀服务品牌，务求为客户带来更完美的投资感受。`,
                      'en': `Xinhuibao Precious Metals create first class service system for client, online customer service, account opening, information , demo trading, daily analysis, trading strategy etc..  High-quality, professional online platform construction and services, stable MT4 trading system, secure fund management, and all-day elite team consulting services. The company is committed to improve the customer service transaction experience, professional quality, and establish an excellent service brand, in order to bring a more perfect investment experience for customer.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `在客戶服務方面，鑫匯寶貴金屬不斷推陳出新，回饋客戶的活動也此起彼伏，開戶送金、限時優惠、手續費減免等。讓廣大投資者享受到更多優惠和便利。2016年新年開始，鑫匯寶貴金屬將一如既往推出感恩回饋客戶優惠活動，客戶可隨時關注官網:www.91pme.com，新一期的優惠活動即將推出!`,
                      'sc': `在客户服务方面，鑫汇宝贵金属不断推陈出新，回馈客户的活动也此起彼伏，开户送金、限时优惠、手续费减免等。让广大投资者享受到更多优惠和便利。2016年新年开始，鑫汇宝贵金属将一如既往推出感恩回馈客户优惠活动，客户可随时关注官网:www.91pme.com，新一期的优惠活动即将推出!`,
                      'en': `In customer service, Xinhuibao Precious Metals keep to launch new promotion, feedback to our client. Account opening promotion, and fee reductions, etc... let our client enjoy more benefits and convenience. At the beginning of the 2016, Xinhui's  Xinhuibao Precious Metals will keep launch grateful promotion, and please always pay attention to the official website: www.91pme.com, the new season's special offers are coming soon!`
                  })
                }
              </p>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default News20161118001



// WEBPACK FOOTER //
// ./src/components/pages/PC20161118001.js